import { TimerEditOutlineIcon } from './TimerEditOutlineIcon';

/**
 * author: Colton Wiscombe
 * id D16F03BE-957E-44F1-AD89-C18C340311BD
 * name timer-edit-outline
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/timer-edit-outline.svg
 * tags
 * - Date / Time 
 * - Edit / Modify 
 */
export const StopwatchEditOutlineIcon = TimerEditOutlineIcon;
export default StopwatchEditOutlineIcon